import { useEffect, useState } from 'react';

import DeliveryInsuranceConfigurationDisplay from './delivery-insurance/delivery-insurance-configuration-display.component';
import ReshipConfigurationDisplay from './reship/reship-configuration-display.component';
import ShippingConfigurationDisplay from './shipping/shipping-configuration-display.component';
import Spinner from '../../../reusable/spinner/spinner.component';

import Client from '../../../../tools/client';

import {
  Container,
  FieldSection,
  FieldGroup,
  SectionTitle,
  Label,
  Toggle,
  ButtonRow,
  Button
} from '../configuration-sections.styles';

const client = new Client();

const ShopConfigurationDisplay = () => {
  const [loading, setLoading] = useState(true);
  const [config, setConfig] = useState({});
  const [editing, setEditing] = useState(false);
  const [shopActive, setShopActive] = useState(true);

  useEffect(() => {
    fetchConfig();
  }, []);

  const fetchConfig = async () => {
    setLoading(true);
    const res = await client.setup();
    const shop = res.configuration?.shop || {};
    setConfig(shop);
    setShopActive(shop.active === 'true' || shop.active === true);
    setLoading(false);
  };

  const handleSave = async () => {
    await client.updateConfigurationByKey('shop.active', {
      value: String(shopActive)
    });
    setEditing(false);
  };

  if (loading) return <Spinner />;

  return (
    <Container>
      {/* <FieldSection>
        <SectionTitle>Shop</SectionTitle>
        <FieldGroup>
          <Label>Shop Active</Label>
          <Toggle>
            <input
              type="checkbox"
              checked={shopActive}
              onChange={() => setShopActive(!shopActive)}
              disabled={!editing}
            />
            <span />
          </Toggle>
        </FieldGroup>
        <ButtonRow>
          {editing ? (
            <>
              <Button onClick={() => setEditing(false)}>Cancel</Button>
              <Button primary onClick={handleSave}>Save</Button>
            </>
          ) : (
            <Button primary onClick={() => setEditing(true)}>Edit</Button>
          )}
        </ButtonRow>
      </FieldSection> */}

      <FieldSection>
        <SectionTitle>Delivery Insurance</SectionTitle>
        <DeliveryInsuranceConfigurationDisplay />
      </FieldSection>

      <FieldSection>
        <SectionTitle>Shipping Settings</SectionTitle>
        <ShippingConfigurationDisplay />
      </FieldSection>

      {/* TODO - Add back in once reship is ready */}
      {/* <FieldSection>
        <SectionTitle>Reship Settings</SectionTitle>
        <ReshipConfigurationDisplay />
      </FieldSection> */}
    </Container>
  );
};

export default ShopConfigurationDisplay;